(function($) {
	var doSlides = function() {
		var slideWidth = $('li.slide').width();
		var windowHeight = $(window).height();
		var headerHeight = $('.site-header').height();
		var submenuHeight = $('.section-nav').height();
		var slideHeight = windowHeight - headerHeight - submenuHeight;
		$('li.slide').height(slideHeight + submenuHeight);
		$('li.slide > img').each(function(){
			var imgWidth = $(this).width();
			var imgHeight = $(this).height();
			if(imgHeight > slideHeight) {
				$(this).css({
					'width' : 'auto',
					'max-width' : '95%',
					'height' : slideHeight
				});
			} else {
				$(this).css('margin-top', (slideHeight - imgHeight) / 2);
			}
		});
		$('#flex-images').flexslider({
			animation: 'slide',
			controlNav: false,
			slideshow: false
		});
	}
	
	$(window).load(function() {
		doSlides();
		$('li.slide').css('opacity', '1');
	});
	$(window).resize(function() {
		doSlides();
	});
})(jQuery);